module.exports = __webpack_public_path__ + "static/media/3.12_preview.9025f92d.png";